import { render, staticRenderFns } from "./HomeForumBlock.vue?vue&type=template&id=02e55335&scoped=true&"
import script from "./HomeForumBlock.vue?vue&type=script&lang=js&"
export * from "./HomeForumBlock.vue?vue&type=script&lang=js&"
import style0 from "./HomeForumBlock.vue?vue&type=style&index=0&id=02e55335&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e55335",
  null
  
)

export default component.exports